import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../../shared/ui/kit/utils';

interface ToggleSettingProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    size?: 'sm' | 'md';
}

export const ToggleSetting: React.FC<ToggleSettingProps> = ({
    checked,
    onChange,
    disabled = false,
    size = 'md',
}) => {
    const sizes = {
        sm: { track: 'w-9 h-5', thumb: 'w-4 h-4', translate: 'translate-x-[18px]' },
        md: { track: 'w-11 h-6', thumb: 'w-5 h-5', translate: 'translate-x-[22px]' },
    };

    const s = sizes[size];

    return (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            disabled={disabled}
            onClick={() => onChange(!checked)}
            className={cn(
                'relative rounded-full transition-all duration-200 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--bg-elevated)]',
                s.track,
                checked 
                    ? 'bg-[var(--brand)]' 
                    : 'bg-[var(--bg-hover)] border border-[var(--border)]',
                disabled && 'opacity-50 cursor-not-allowed'
            )}
        >
            <motion.div
                className={cn(
                    'absolute top-0.5 left-0.5 rounded-full bg-white shadow-sm',
                    s.thumb
                )}
                animate={{
                    x: checked ? (size === 'sm' ? 18 : 22) : 0,
                }}
                transition={{
                    type: 'spring',
                    stiffness: 500,
                    damping: 30,
                }}
                style={{
                    boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
                }}
            />
        </button>
    );
};